import React, {FC} from 'react';
import styled from 'styled-components';
import {palette, transition, mediaBreakpointDown} from '../../lib/styleVariables';
import {Overlay} from '../../components/molecules/overlay';
import {Icon} from '../../components/molecules/icon';
import {SubscriptionForm} from './subscriptionForm';
import {Handler} from '../../lib/typeHelpers';
import {convertHexToRGBA} from '../../lib/color-utils';

interface OverlayProps {
  isOpen: boolean;
  onClose: Handler;
  subscriptionFormEmbedData: any;
  title: string | null | undefined;
}

const StyledOverlayInner = styled.div`
  max-width: 520px;
  max-height: 100vh;
  flex-grow: 1;
  margin: 0 8px;
  padding: 48px;
  background: ${palette.white.highlight};
  box-shadow: 0px 6px 32px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  position: relative;
  overflow: auto;

  ${mediaBreakpointDown('mobile')} {
    padding: 24px;
  }
`;

const StyledCloseIcon = styled.div`
  padding: 8px;
  border-radius: 8px;
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
  transition: ${transition.fast};

  &:hover {
    background: ${convertHexToRGBA(palette.black.base, 0.1)};
  }
`;

export const SubscriptionOverlay: FC<OverlayProps> = props => (
  <Overlay open={props.isOpen} onClose={() => props.onClose()}>
    <StyledOverlayInner>
      <SubscriptionForm
        title={props.title}
        subscriptionFormEmbedData={JSON.parse(props.subscriptionFormEmbedData)}
      />

      <StyledCloseIcon onClick={() => props.onClose()}>
        <Icon name="exit" size={16} />
      </StyledCloseIcon>
    </StyledOverlayInner>
  </Overlay>
);
